import { forwardRef, memo } from 'react';
import { useMediaQuery } from 'react-responsive';

import { Media } from '../../../../../theme/Media.tsx';
import { Button } from '../../../../Controls/Button/index.tsx';
import type { TableActionButtonProps } from './types.ts';

export const TableActionButton = memo(
  forwardRef<HTMLButtonElement, TableActionButtonProps>(function TableActionButton({ children, ...props }, ref) {
    const isMobile = useMediaQuery({ query: Media.xsMax });

    return (
      <Button {...props} iconOnly={!isMobile} ghost ref={ref}>
        {children}
      </Button>
    );
  }),
);
